import { Button, Flex, Popconfirm, Tooltip } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faPaste,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

type ActionButtonsProps = {
  /**
   * @deprecated L2 (PROG-DETAIL/IMPL): the per-item "+" affordance was
   * removed; appending happens through the bottom CTA in SplitListView /
   * ExerciseListView. Kept in the type only because call sites still pass it
   * — the value is ignored.
   */
  onAdd?: () => void;
  onCopy: () => void;
  onPaste?: () => void;
  onDelete: () => void;
  addTooltip?: string;
  copyTooltip?: string;
  pasteTooltip?: string;
  deleteTooltip?: string;
  canEdit: boolean;
  size?: "small" | "default";
};

export default function ActionButtons({
  onCopy,
  onPaste,
  onDelete,
  copyTooltip = "Copia",
  pasteTooltip = "Incolla",
  deleteTooltip = "Elimina",
  canEdit,
  size = "default",
}: ActionButtonsProps) {
  if (!canEdit) return null;

  const antdSize: "small" | "middle" = size === "small" ? "small" : "middle";

  return (
    <Flex gap={size === "small" ? 4 : 6} align="center">
      <Tooltip title={copyTooltip}>
        <Button
          type="text"
          size={antdSize}
          aria-label={copyTooltip}
          onClick={(e) => { e.stopPropagation(); onCopy(); }}
          icon={<FontAwesomeIcon icon={faCopy} />}
        />
      </Tooltip>
      {onPaste && (
        <Tooltip title={pasteTooltip}>
          <Button
            type="text"
            size={antdSize}
            aria-label={pasteTooltip}
            onClick={(e) => { e.stopPropagation(); onPaste(); }}
            icon={<FontAwesomeIcon icon={faPaste} />}
          />
        </Tooltip>
      )}
      <Popconfirm
        title="Conferma eliminazione"
        description="Sei sicuro di voler eliminare questo elemento?"
        icon={<ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />}
        onConfirm={(e) => { e?.stopPropagation(); onDelete(); }}
        onCancel={(e) => e?.stopPropagation()}
        okText="Elimina"
        cancelText="Annulla"
        okButtonProps={{ danger: true }}
      >
        <Tooltip title={deleteTooltip}>
          <Button
            type="text"
            size={antdSize}
            danger
            aria-label={deleteTooltip}
            onClick={(e) => e.stopPropagation()}
            icon={<FontAwesomeIcon icon={faTrash} />}
          />
        </Tooltip>
      </Popconfirm>
    </Flex>
  );
}
